<template>
  <card :class="['badges', 'mr-3', 'pointer-events-none']">
    <card-actions align="left" padding-off>
      <ul :class="['inline-list', 'mt-2', 'mx-1']">
        <li v-for="(badge, index) in badges" :key="index" :class="['mx-1', 'mb-2']">
          <badge-generator
            :title="`${badge.subject} (${badge.status})`"
            :subject-bg-color="badge.subjectBgColor"
            :subject-color="badge.subjectColor"
            :status-bg-color="badge.statusBgColor"
            :status-color="badge.statusColor"
            :icon="badge.icon"
            :subject="badge.subject"
            :status="badge.status" />
        </li>
      </ul>
    </card-actions>
  </card>
</template>
<script>
import methods from '../mixins/methods'

export default {
  name: 'Badges',
  mixins: [
    methods
  ],
  data () {
    return {
      badges: []
    }
  },
  mounted () {
    this.setBadges()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/badges.vue